export default __webpack_public_path__ + "static/media/Scholar's Belt of the Effulgent Blade.0b215159.jpg";